let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e3pdj")).then(() => parcelRequire('f2cHH'));